import { RosterLevelType } from '@wwe-portal/entities/roster.type';
import { cn } from '@wwe-portal/ui/lib/lib';
import {
  FullLevelStar,
  HollowFullLevelStar,
  HollowLevelStar,
  LevelStar,
} from './level-star';
import { forwardRef } from 'react';
import { genArrayWithId } from '@wwe-portal/utils/array';

export interface RosterStarData {
  rate: number;
  hollowStar: number;
  level: RosterLevelType;
}

export interface RosterStarProps extends RosterStarData {
  className?: string;
  size?: number;
  short?: boolean;
}

export const RosterStar = forwardRef<HTMLDivElement, RosterStarProps>(
  ({ rate, hollowStar, level, className, size, short = true }, ref) => {
    const showFullStar = rate + hollowStar >= 6 && short;
    const hasHollowStar = hollowStar > 0;

    return (
      <div
        ref={ref}
        className={cn(
          'drop-shadow-text flex cursor-pointer items-center justify-center gap-1',
          className
        )}
      >
        {showFullStar && !hasHollowStar && (
          <FullLevelStar level={level} size={size} />
        )}
        {showFullStar && hasHollowStar && (
          <HollowFullLevelStar level={level} size={size} />
        )}
        {!showFullStar && (
          <>
            {genArrayWithId(rate).map(({ id }) => (
              <LevelStar key={id} level={level} size={size} />
            ))}
            {genArrayWithId(hollowStar).map(({ id }) => (
              <HollowLevelStar key={id} level={level} size={size} />
            ))}
          </>
        )}
      </div>
    );
  }
);

RosterStar.displayName = 'RosterStar';
